import { render, staticRenderFns } from "./SitchDropdown.vue?vue&type=template&id=1d33dc7c&scoped=true&"
import script from "./SitchDropdown.vue?vue&type=script&lang=ts&"
export * from "./SitchDropdown.vue?vue&type=script&lang=ts&"
import style0 from "./SitchDropdown.vue?vue&type=style&index=0&id=1d33dc7c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d33dc7c",
  null
  
)

export default component.exports